import { createAction, props } from '@ngrx/store';

export const setLang = createAction(
  '[Config] Set Lang',
  props<{ payload: string }>()
);
